export const ACTOR_ROUTE_NAMES = {
  ACTORPROFILEVIEW: 'actor-profile-view',
  MYBOOK: 'mybook',
  /*ROUTE_NAME*/
};
